<template>
  <div id="app">
    <TheTopNav/>
    
    <div class="content-wrapper">
        <router-view/>
    </div>

    <TheFooter/>
    <TheLoader/>

    <ModalCard/>
    <ModalBattle/>
    <ModalAuction/>
    <ModalResults/>
    
    <!-- Third Party Plugin -->
    <notifications group="app" position="top center" classes="app-notification"/>
  </div>
</template>

<script>
import TheTopNav from './components/layout/TheTopNav';
import TheFooter from './components/layout/TheFooter';
import TheLoader from './components/layout/TheLoader';
import ModalAuction from './components/ModalAuction';
import ModalBattle from './components/ModalBattle';
import ModalResults from './components/ModalResults';
import ModalCard from './components/ModalCard';
import Chat from './components/chat/Chat';
import { mapGetters } from "vuex";

export default {
    name: 'App',
    beforeCreate () {
        
        // Restore from storage
        this.$store.commit('restoreLocale');
          
    },
    computed: {
        ...mapGetters({
            'locale' : 'getLocale'
        })
    },
    methods: {
        isMobileDevice () {
            return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
        }
    },
    created () {

        // Set locale, from storage
        this.$i18n.set(this.locale);

        setTimeout(() => {
            if(typeof(webExtensionWallet) === "undefined" && !this.isMobileDevice()){
                this.$store.commit('updateHasExtension', { hasExtension: false });
            } else {
                // this.$store.dispatch('initLoaders');
                this.$store.dispatch('initBlockchainData');  
            }

            this.$store.commit('updateLoading', { loading: false });
        }, 1500);  
    },
    components: {
        TheFooter,
        TheLoader,
        TheTopNav,
        ModalCard,
        ModalBattle,
        ModalAuction,
        ModalResults,
        Chat
    }
}
</script>

<style lang="less">
@import 'bootstrap/dist/css/bootstrap.css';
@import 'bootstrap-vue/dist/bootstrap-vue.css';
@import "https://use.fontawesome.com/releases/v5.0.8/css/all.css";
@import "./assets/less/modal.less";
@import "./assets/less/app.less";
@import "./assets/less/nav.less";
</style>



// WEBPACK FOOTER //
// src/App.vue